import { render } from "./CatalogoConversion.vue?vue&type=template&id=86991a64&scoped=true"
import script from "./CatalogoConversion.vue?vue&type=script&lang=js"
export * from "./CatalogoConversion.vue?vue&type=script&lang=js"

import "./CatalogoConversion.vue?vue&type=style&index=0&id=86991a64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86991a64"]])

export default __exports__